/*
 * Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MessageComponent } from './message.component';

@NgModule({
  declarations: [],
  exports: [MessageComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MessageComponent
  ]
})
export class MessageModule { }
